import { createFileRoute } from '@tanstack/react-router';
import { ReviewerInspections } from '@/components/reviewer-inspections';
import { usePermissions } from '@/hooks/use-permissions';
import { PERMISSIONS } from '@property/shared';

export const Route = createFileRoute('/dashboard/reviews/')({
  component: ReviewsPage,
});

function ReviewsPage() {
  const { can } = usePermissions();
  return <div>{can(PERMISSIONS.INSPECTIONS_REVIEW) && <ReviewerInspections />}</div>;
}
